module.exports = __webpack_public_path__ + "img/symbol_16.1f82d42b.png";